'use strict';

import { Color, LinearSRGBColorSpace, OrthographicCamera, Scene, WebGLRenderer } from 'three';
import { Loop } from './Loop';

export class World {
    constructor (canvas,width,height,pixelRatio) {
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this.pixelRatio = pixelRatio;
    }

    initScene() {
        this.scene = new Scene();
        this.scene.background = new Color().setStyle('#ffffff',LinearSRGBColorSpace);
        this.camera = new OrthographicCamera(-1, 1, 1, -1, 0, 100);
        this.camera.position.z = 1;
        this.renderer = new WebGLRenderer({
            antialias: false,
            canvas: this.canvas,
            stencil: false
        });
        this.renderer.sortObjects = true;
        this.renderer.shadowMap.enabled = false;
        this.renderer.setSize(this.width,this.height,false);
        this.renderer.setPixelRatio(this.pixelRatio);
        this.loop = new Loop(this);
    }

    render() {
        this.renderer.render(this.scene, this.camera);
    }

    start() {
        this.loop.start();
    }

    stop() {
        this.loop.stop();
    }

    addToScene(obj) {
        this.scene.add(obj);
    }

    setSize(width,height) {
        this.width = width;
        this.height = height;
        this.renderer.setSize(this.width,this.height,false);
        this.camera.updateProjectionMatrix();
        this.renderer.render(this.scene,this.camera);
    }
}
